<template>
	<div
		class="newsletter-wrapper"
		:class="this.position"
	>
		<NoSsr>
			<div
				:class="unpaginatedFlag"
				v-if="this.position !== 'overlay'"
				class="newsletter-container"
				:data-chronicle="chronicId"
			>
				<div
					class="newsletter-main"
					v-if="((!isSuccess && !isError) || ((isSuccess || isError)
						&& this.nlConfig.showCustomSuccessContainer))
						|| ((isInfinite || isToc) && nlType === 'in-article')"
					:class="((isSuccess || isError) && this.nlConfig.showCustomSuccessContainer)
						? 'cust-nl-suc': ''"
				>
					<div class="header-container">
						<div
							class="image-container"
							v-if="isInfinite && nlType === 'in-article' && !isToc"
						>
							<div
								class=""
								v-html="getImagePath()"
							>
							</div>
						</div>
						<div
							class="nl-header-container"
							v-if="(!isSuccess && !isError)"
						>
							<h3
								v-html="this.nlHeader"
							></h3>
							<div>
								<h4
									v-if="this.position !== 'right'"
									v-html="this.nlSubHeader"
								>
								</h4>
							</div>
						</div>
						<div
							class="success-reg"
							:class="{'in-art-ty': (isInfinite && nlType === 'in-article')}"
							v-if="isSuccess && !isToc && (isInfinite && nlType === 'in-article')"
						>
							<h2>{{ nlThanks.thankYouMessageTitle }}</h2>
							<span class="sub-title-text">
								{{ nlThanks.thankYouMessageSubTitle }}
							</span>
							<div class="see-more-container">
								<a
									class="see-more-btn"
									:href="nlThanks.thankYouMessageLink"
									v-metric="{module:'nl-ty'}"
								>
									{{ nlThanks.thankYouMessageLinkTextButton }}
								</a>
							</div>
						</div>
						<div
							class="err-reg"
							v-if="isError && !isSuccess && !isOncology && !isToc
								&& (isInfinite && nlType === 'in-article')"
						>
							<p>This feature is temporarily unavailable.</p>
							<p>
								Please visit our <a href="https://member.webmd.com/subscribe">
									Newsletter Preference Center
								</a> for all of our available subscription options.
							</p>
						</div>
					</div>
					<div class="content-container">
						<div
							class="webmd-logo-container"
							v-if="!isToc"
							:class="{'sucess-webmd-logo': (isSuccess && (isInfinite && nlType === 'in-article'))}"
						>
							<img
								:src="(this.nlConfig.webmdLogoImg !== '') ?
									this.nlConfig.webmdLogoImg : this.webmdLogo"
								class="newsletter-daily-logo"
								alt="WebMD: Better information. Better health."
								title="WebMD: Better information. Better health."
								loading="lazy"
							/>
						</div>
						<div v-if="(!isSuccess && !isError) || isFed || isToc">
							<div
								v-if="isMultiple"
								class="multie-nl-container"
							>
								<WebmdCheckbox
									v-for="(nums) in this.multiNLList"
									:key="nums.id"
									:label="nums.title"
									@change="updateArray(nums.id)"
								/>
							</div>
							<div
								v-if="newsletterList && newsletterList.child_newsletters"
								class="series-select"
							>
								<WebmdCheckbox
									v-for="(item) in newsletterList.child_newsletters"
									:key="item.message_id"
									:label="item.title"
									@change="toggleSeriesCheck(item.message_id)"
									size="small"
								/>
							</div>
							<div
								class="email-container"
								v-if="(!isSuccess && !isError)"
							>
								<WebmdInput
									class="email-input"
									placeholder="Enter your email address"
									labeltype="noLabel"
									size="medium"
									v-model="email"
								/>
								<WebmdButton
									type="primary"
									@click="submitForm()"
									:disabled="disableButton()"
								>
									Subscribe
								</WebmdButton>
							</div>
							<div
								class="thanks-cont"
								v-if="isSuccess && isToc && newsletterList"
							>
								<div class="container">
									<div class="left-cont">
										<svg
											width="48"
											height="48"
											viewBox="0 0 48 48"
											fill="none"
											xmlns="http://www.w3.org/2000/svg"
										>
											<!-- eslint-disable max-len -->
											<path
												d="M23.75 0.5C10.6505 0.5 0 11.1505 0 24.25C0 37.3495 10.6505 48 23.75 48C36.8495 48 47.5 37.3495 47.5 24.25C47.5 11.1505 36.8495 0.5 23.75 0.5ZM23.75 45.0995C12.25 45.0995 2.9005 35.75 2.9005 24.25C2.9005 12.75 12.25 3.4005 23.75 3.4005C35.25 3.4005 44.5995 12.75 44.5995 24.25C44.5995 35.75 35.25 45.0995 23.75 45.0995Z"
												fill="#74b2ff"
											/>
											<path
												d="M20.7499 28.6506L13.5994 21.5001L11.0505 24.0509L20.7495 33.7499L37.349 17.1504L34.7494 14.5996L20.7499 28.6506Z"
												fill="#74b2ff"
											/>
											<!-- eslint-enable max-len -->
										</svg>
									</div>
									<div class="right-cont">
										<h2>{{ nlThanks.thankYouMessageTitle }}</h2>
										<span class="sub-title-text">
											{{ nlThanks.thankYouMessageSubTitle }}
										</span>
										<div class="see-more-container">
											<a
												class="see-more-btn"
												:href="nlThanks.thankYouMessageLink"
												v-metric="{module:'nl-ty'}"
											>
												{{ nlThanks.thankYouMessageLinkTextButton }}
											</a>
										</div>
									</div>
								</div>
							</div>
							<div
								class="err-reg"
								v-if="!isSuccess && isError && isToc"
							>
								<p>This feature is temporarily unavailable.</p>
								<p>
									Please visit our <a :href="newsletterList.thankYouMessageLink">
										.					Newsletter Preference Center
									</a> for all of our available subscription offerings.
								</p>
							</div>

							<!-- Oncology pages require inline success message. This is always hidden but
							on Oncology pages we override styles to display -->
							<div class="inline-suc-msg">
								<img
									:src="(this.nlConfig.successCheckMark !== '') ?
										this.nlConfig.successCheckMark : this.checkMarkImg"
								/>
								<div class="success">
									<h2>{{ nlThanks.thankYouMessageTitle }}</h2>
									<h3>{{ email }}</h3>
								</div>
							</div>
							<span class="err-invalid-email" v-if="invalidEmail">{{ errorMessage }}</span>
							<!-- eslint-disable -->
							<div class="nl-disclaimer" v-metric="{module:'nl-hov'}">By clicking Subscribe, I agree to the
								WebMD <a
									href="https://www.webmd.com/about-webmd-policies/about-terms-and-conditions-of-use"
									class="newsletter-terms"
									target="_blank"
									v-metric="{link: 'tc', type: 'adhoc'}"
								>Terms & Conditions </a>&<a
									href="https://www.webmd.com/about-webmd-policies/about-privacy-policy"
									class="newsletter-privacy"
									target="_blank"
									v-metric="{link: 'pp', type: 'adhoc'}"
								> Privacy Policy</a> and understand that I may opt
								out of
								WebMD subscriptions at any time. This site is protected by reCAPTCHA and the Google
								<a
									@click.prevent="handleOffsiteRedirect({url: 'https://policies.google.com/privacy', newWindow:'_blank'})"
									href="https://policies.google.com/privacy"
								>Privacy Policy</a> and 
								<a
									@click.prevent="handleOffsiteRedirect({url: 'https://policies.google.com/terms', newWindow:'_blank'})"
									href="https://policies.google.com/terms"
								>Terms of Service</a> apply.
							</div>
						</div>
						<!-- eslint-enable -->
					</div>
					<div
						class="image-container"
						v-if="isToc && nlType === 'in-article'"
					>
						<div
							class=""
							v-html="getImagePath()"
						>
						</div>
					</div>
				</div>
				<div
					class="success-reg"
					v-if="isSuccess && !isToc && !(isInfinite && nlType === 'in-article')"
				>
					<h2>{{ nlThanks.thankYouMessageTitle }}</h2>
					<span class="sub-title-text">
						{{ nlThanks.thankYouMessageSubTitle }}
					</span>
					<div class="see-more-container">
						<a
							class="see-more-btn"
							:href="nlThanks.thankYouMessageLink"
							v-metric="{module:'nl-ty'}"
						>
							{{ nlThanks.thankYouMessageLinkTextButton }}
						</a>
					</div>
				</div>
				<div
					class="err-reg"
					v-if="isError && !isToc && !(isInfinite && nlType === 'in-article')"
				>
					<div
						class="nl-header-container"
						v-if="!isToc"
					>
						<h2 v-html="this.nlHeader"></h2>
					</div>
					<p>This feature is temporarily unavailable.</p>
					<p>
						Please visit our <a :href="newsletterList.thankYouMessageLink">
							Newsletter Preference Center
						</a> for all of our available subscription offerings.
					</p>
				</div>
			</div>
		</NoSsr>
		<WebmdButton
			type="secondary"
			@click="resetHover"
			v-if="this.position === 'overlay'"
		>
			Subscribe
		</WebmdButton>
		<WebmdDialog
			:visible="showHover"
			:before-close="closeHover"
		>
			<div
				class="newsletter-main"
				:class="this.position"
				v-if="(!isSuccess && !isError)"
			>
				<div
					class="nlhover-image-container"
					v-html="getImagePath()"
				>
				</div>
				<div class="nlhov-content-container">
					<div class="nl-header-container">
						<h2 v-html="this.nlHeader"></h2>
						<h3
							v-html="this.nlSubHeader"
						>
						</h3>
					</div>
					<div
						v-if="isMultiple"
						class="multie-nl-container"
					>
						<WebmdCheckbox
							v-for="nums in this.multiNLList"
							:key="nums.id"
							:label="nums.title"
							@change="updateArray(nums.id)"
						/>
					</div>
					<div
						v-if="newsletterList.child_newsletters"
						class="series-select"
					>
						<WebmdCheckbox
							@change="toggleSeriesCheck(item.message_id)"
							:label="item.title"
							size="small"
							v-for="(item) in newsletterList.child_newsletters"
							:key="item.message_id"
						/>
					</div>
					<div class="email-container">
						<WebmdInput
							class="email-input"
							placeholder="Enter your email address"
							labeltype="noLabel"
							size="medium"
							v-model="email"
							@focus="focus"
							@blur="blur"
						/>
						<WebmdButton
							type="primary"
							@click="submitForm()"
							:disabled="disableButton()"
						>
							Subscribe
						</WebmdButton>
					</div>
					<span class="err-invalid-email" v-if="invalidEmail">{{ errorMessage }}</span>
					<!-- eslint-disable -->
					<div class="nl-disclaimer" v-metric="{module:'nl-hov'}">By clicking Subscribe, I agree to the
						WebMD <a
							href="https://www.webmd.com/about-webmd-policies/about-terms-and-conditions-of-use"
							class="newsletter-terms"
							target="_blank"
							v-metric="{link: 'tc', type: 'adhoc'}"
						>Terms & Conditions </a>&<a
							href="https://www.webmd.com/about-webmd-policies/about-privacy-policy"
							class="newsletter-privacy"
							target="_blank"
							v-metric="{link: 'pp', type: 'adhoc'}"
						> Privacy Policy</a> and understand that I may opt out of WebMD subscriptions at any time.
						This site is protected by reCAPTCHA and the Google
								<a
									@click.prevent="handleOffsiteHover('https://policies.google.com/privacy')"
									href="https://policies.google.com/privacy"
								>Privacy Policy</a> and 
								<a
									@click.prevent="handleOffsiteHover('https://policies.google.com/terms')"
									href="https://policies.google.com/terms"
								>Terms of Service</a> apply.
					</div>
					<!-- eslint-enable -->
				</div>
			</div>
			<div
				class="success-reg"
				:class="this.position"
				v-if="isSuccess"
			>
				<div
					class="nlhover-image-container"
					v-html="getImagePath()"
				>
				</div>
				<div class="success-content">
					<h2>{{ nlThanks.thankYouMessageTitle }}</h2>
					<span class="sub-title-text">
						{{ nlThanks.thankYouMessageSubTitle }}
					</span>
					<div class="see-more-container">
						<a
							class="see-more-btn"
							:href="nlThanks.thankYouMessageLink"
							v-metric="{module:'nl-ty'}"
						>
							{{ nlThanks.thankYouMessageLinkTextButton }}
						</a>
					</div>
				</div>
			</div>
			<div
				class="err-reg"
				:class="this.position"
				v-if="isError"
			>
				<div
					class="nlhover-image-container"
					v-html="getImagePath()"
				>
				</div>
				<div class="error-content">
					<div class="nl-header-container">
						<h2 v-html="this.nlHeader"></h2>
					</div>
					<p>This feature is temporarily unavailable.</p>
					<p>
						Please visit our <a :href="newsletterList.thankYouMessageLink">
							Newsletter Preference Center
						</a> for all of our available subscription offerings.
					</p>
				</div>
			</div>
		</WebmdDialog>
	</div>
</template>

<script>
// eslint-disable-next-line import/no-extraneous-dependencies
import useStore from 'webmd-cms-store/src/store';

import axios from 'axios';
import {
	Button, Checkbox, Input, Dialog,
} from 'webmd-elements';
import { ua } from 'webmd-useragent';
import _has from 'lodash/has';
import _pick from 'lodash/pick';
import { increment } from 'webmd-pim';
import { getParam, getSLD } from 'webmd-url';
import cookie from 'webmd-cookie';
import regservice from 'webmd-reg-service/index.es6';
import NoSsr from './client-only';
import newsletterMapping from './lib/newsletterMapping.es6';
import auth from './lib/authmodule.es6';
import suppressAutoHover from './lib/suppressAutoHover.es6';
import sfNewsLetterMixin from './mixins/SfNewsLetter.mixins.es6';
import offsiteLinks from 'webmd-offsite/index.es6';

export default {
	name: 'WebmdNewsletter',
	data() {
		return {
			closeOverlay: false,
			showHover: false,
			dialogVisible: false,
			unpaginatedFlag: '',
			nlHeader: '',
			nlSubHeader: '',
			nlSuccessHeader: '',
			nlThanks: {
				thankYouMessageTitle: 'Thanks for signing up!',
				thankYouMessageSubTitle: 'See all of WebMD\'s health and wellness newsletters.',
				thankYouMessageLinkTextButton: 'See More',
				thankYouMessageLink: 'https://www.webmd.com/newsletters',
			},
			centerId: '',
			checkList: [],
			newsletterList: [],
			nlSeries: [],
			email: '',
			omniture: {},
			isSuccess: false,
			isError: false,
			requestHeader: {},
			position: '',
			moduleData: {},
			isMetricLaunchTagAvailable: false,
			invalidEmail: false,
			errorMessage: '',
			duAgent: '',
			webmdLogo: 'https://img.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/logos/webmd/web/webmd_logo.svg',
			isFocused: false,
			nlAutoHoverConfig: {
				nlAutoOpenTimeout: 3000,
				nlAutoCloseTimeout: 30000,
			},
			checkMarkImg: 'https://img.webmd.com/dtmcms/live/webmd/consumer_assets/site_images/newsletters/overlay/follow-checkmark.png',
			emailEncodedGuid: '',
			isProdApiUrl: false,
			isMultiple: false,
			mmoduleData: this.mmodule,
			mlinkData: this.mlink,
		};
	},
	mixins: [sfNewsLetterMixin, offsiteLinks],
	props: {
		numOfMultiNls: {
			type: Number,
			default: 4,
		},
		mmodule: {
			type: String,
			default: '',
		},
		mlink: {
			type: String,
			default: '',
		},
		location: {
			type: String,
			default: undefined,
		},
		chronicId: {
			type: String,
			required: false,
		},
		nlConfig: {
			type: Object,
			default() {
				return {
					id: '',
					centerId: '',
					header: '',
					subHeader: '',
					mmodule: '',
					mlink: '',
					webmdLogoImg: '',
					successCheckMark: '',
				};
			},
		},
		btnMmodule: {
			type: String,
			default: 'nl-mast',
		},
		btnMlink: {
			type: String,
			default: 'sub',
		},
		autoHover: {
			type: Boolean,
			default: false,
		},
		nlType: {
			type: String,
			default: '',
		},
		isToc: {
			type: Boolean,
			default: false,
		},

	},
	components: {
		WebmdButton: Button,
		WebmdCheckbox: Checkbox,
		WebmdInput: Input,
		WebmdDialog: Dialog,
		NoSsr,
	},
	computed: {
		isOncology() {
			return this.store.pagedata.isOncology;
		},

		hasEventListener() {
			return this.$listeners && this.$listeners.subscribeNL;
		},
		isInfinite() {
			return this.store.flow.isInfinite;
		},
		getModuleData() {
			let module = this.store.cms.getModules(this.chronicId);
			module = module && _has(module, 'module_settings')
				? _pick(module, ['module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val'])
				: {};

			this.store.cms.UPDATE_STATE({ key: this.chronicId, value: module });
			return module;
		},
		getCenterId() {
			const centerId = _has(this.store, 'pagedata.omniture.center_id')
				? this.store.pagedata.omniture.center_id
				: '';
			return centerId;
		},
	},
	methods: {
		handleOffsiteHover(redirectUrl) {
			this.handleOffsiteRedirect({ url: redirectUrl, newWindow: '_blank' });
		},
		submitForm() {
			// eslint-disable-next-line no-nested-ternary,max-len
			regservice.subscribetoNL(this.email, this.newsletterList.child_newsletters ? this.nlSeries.length > 0 ? this.nlSeries : [this.newsletterList.child_newsletters[0].message_id] : this.isMultiple ? this.checkList.toString() : this.nlConfig?.id ? this.newsletterList.id : this.newsletterList.message_id).then((response) => {
				try {
					if (this.hasEventListener) {
						this.$emit('subscribeNL', true);
					}

					if (window && window.viewAllContent && this.position !== 'overlay' && this.nlConfig.mmodule === '' && this.nlConfig.mlink === '') {
						this.mmoduleData = this.isMultiple ? 'nl-multie' : 'nl-single';
						this.mlinkData = this.getMlinkValue(response);
					} else {
						this.mmoduleData = this.mmodule || this.getMmoduleValue();
						this.mlinkData = this.getMlinkValue(response);
					}
					
					if (response?.code === 3 || response?.code === 1) {
						this.isSuccess = true;
					} else {
						this.isError = true;
					}

					if (response.code === 3) {
						window.wmdPageLink('reg-success_l-nl');
					}
					if (this.launchTagsAvailability()) {
						window.wmdPageLink({ moduleName: `${this.mmoduleData}_${this.mlinkData}` });
					} else {
						window.wmdPageLink(`${this.mmoduleData}_${this.mlinkData}`);
					}
					this.mmoduleData = '';
					this.mlinkData = '';
				} catch (err) {
					if (err.message === "INVALID EMAIL") {
						this.invalidEmail = true;
						this.errorMessage = err.displayErr; // You need to ensure that the error object includes displayErr
					} else {
						this.error = true; // Generic error handling
					}
				}
			}).catch((err) => {
				if (err.message === "INVALID EMAIL") {
					this.invalidEmail = true;
					this.errorMessage = err.displayErr; // Ensure this error is returned correctly
				} else {
					this.isError = true; // Handling other errors from the registration service
				}
			});
		},
		toggleSeriesCheck(item) {
			if (this.nlSeries.includes(item)) {
				this.nlSeries = this.nlSeries.filter((n) => n !== item);
			} else {
				this.nlSeries.push(item);
			}
		},
		setRegUuidCookie() {
			// Currently all lower environments are using staging API to subscribe.
			let hashUrl = 'https://www.staging.webmd.com/api/svcgateway/v2/reg/regservice.asmx/GetHashEmail';
			if (this.isProdApiUrl) {
				hashUrl = 'https://www.webmd.com/api/svcgateway/v2/reg/regservice.asmx/GetHashEmail';
			}
			axios({
				method: 'POST',
				url: hashUrl,
				data: {
					EncryptedGuid: getParam('mb'),
				},
				headers: auth.generate({ isHashRequest: true }),
			}).then((response) => {
				if (response && response.data && response.data.Email !== '') {
					this.emailEncodedGuid = response.data.Email;
					cookie.set('REG_UUID', this.emailEncodedGuid.toLowerCase(), { expires: 365 * 100, domain: getSLD() });

					/*
					 * Liveramp requested us to use the following snippet to fire a call to track
					 * https://jira.internetbrands.com/browse/PPE-346246
					 */
					if (window && window.ats && window.ats.start) {
						window.localStorage.removeItem('_lr_env');
						window.ats.start({
							placementID: 1293,
							emailHashes: [response.data.Email.trim().toLowerCase()],
						});
					}

					/*
					 * Calling the rpa method for Amazon publisher services if hash key is available
					 * jira.internetbrands.com/browse/PPE-356589
					 */
					if (window && cookie.get('REG_UUID') !== '') {
						window.tokenConfig = { optOut: false, hashedRecords: [] };
						if (window.OptanonActiveGroups && window.OptanonActiveGroups.indexOf('C0004') === -1) {
							window.tokenConfig.optOut = true;
						}
						window.tokenConfig.hashedRecords = [{ type: 'email', record: response.data.Email.toLowerCase() }];
						if (window.apstag) {
							window.apstag.upa(
								window.tokenConfig,
								() => {
									/* eslint-disable no-console */
									console.log('Amazon token is updated');
								},
							);
						}
					}
				}
			});
		},
		getMmoduleValue() {
			let mModVal;
			if (this.position === 'overlay') {
				mModVal = 'nl-hov';
				if (this.isMultiple) {
					mModVal = 'nl-hov-multie';
				}
			}
			if (this.position === 'right') {
				mModVal = 'nl-right';
				if (this.isMultiple) {
					mModVal = 'nl-multie';
				}
			}
			if (this.position === 'middle') {
				mModVal = 'nlcw-embd';
				if (this.isMultiple) {
					mModVal = 'nlcw-multie';
				}
				if (this.nlConfig.mmodule !== '') {
					mModVal = this.nlConfig.mmodule;
				}
				if ((this.isToc && !this.isMultiple) || this.isFed
					|| (this.isInfinite && !this.isMultiple)) {
					mModVal = 'nl-single';
				}
			}
			return mModVal;
		},
		getMlinkValue(response) {
			let prevIndex = 0;
			let tempIndex;
			let nlIndex;
			let omniLink;
			let newsletterId;

			if (this.newsletterList && this.newsletterList.child_newsletters) {
				if (!this.nlSeries.length) {
					newsletterId = this.newsletterList.child_newsletters[0].message_id;
				} else {
					newsletterId = this.nlSeries.join('-');
				}
			} else if (this.newsletterList?.[0]?.id || this.newsletterList?.id) {
				newsletterId = this.newsletterList?.[0]?.id ?? this.newsletterList?.id;
			} else {
				newsletterId = this.newsletterList ? this.newsletterList.message_id : '';
			}
			if (this.isMultiple) {
				const nlArray = [];
				this.multiNLList.forEach((nList) => {
					nlArray.push(nList.id);
				});
				this.checkList.forEach((val) => {
					if (this.checkList.length > 1) {
						tempIndex = nlArray.indexOf(val) + 1;
						if (prevIndex === 0) {
							prevIndex = tempIndex;
						} else {
							prevIndex = `${prevIndex},${tempIndex}`;
						}
					} else {
						prevIndex = nlArray.indexOf(val) + 1;
					}
					nlIndex = prevIndex;
				});
				if (response.code === 3) {
					omniLink = `n:${nlIndex}`;
				} else {
					omniLink = `e3-${nlIndex}`;
				}
			} else if (response.code === 3) {
				omniLink = `n:${newsletterId}`;
			} else if (response.code === 1) {
				omniLink = `r:${newsletterId}`;
			} else {
				omniLink = 'e3';
			}
			if (this.nlConfig?.mlink) {
				omniLink = this.nlConfig.mlink;
			}
			return omniLink;
		},
		closeHover() {
			this.showHover = false;
			this.email = '';
			this.removeOpenHoverIdFromBodyTag();
			if (this.launchTagsAvailability()) {
				window.wmdPageLink({ moduleName: 'nl-hov_x' });
			} else {
				window.wmdPageLink('nl-hov_x');
			}
		},
		setThanks() {
			const source = this.nlConfig && this.nlConfig.id ? this.nlConfig : this.newsletterList;
			let config = {};

			if (source.thankYouMessageTitle) {
				const {
					thankYouMessageTitle,
					thankYouMessageSubTitle,
					thankYouMessageLinkTextButton,
					thankYouMessageLink,
				} = source;

				config = {
					thankYouMessageTitle,
					thankYouMessageSubTitle,
					thankYouMessageLinkTextButton,
					thankYouMessageLink,
				};
			}

			this.nlThanks = Object.assign(this.nlThanks, config);
		},

		getHeader() {
			let nlHeaderText = 'Sign up for our free Newsletter';
			if (this.isMultiple) {
				nlHeaderText = 'Subscribe to WebMD Newsletters';
			} else if (this.nlConfig.header !== '' && this.nlConfig.header !== undefined) {
				nlHeaderText = this.nlConfig.header;
			} else if (this.newsletterList.title) {
				nlHeaderText = this.newsletterList.title;
			}
			return nlHeaderText;
		},

		getSuccessHeader() {
			let nlSucText = 'Thank you for subscribing to our Newsletter';
			if (this.isMultiple) {
				nlSucText = 'Thank you for subscribing to our Newsletters';
			} else if (this.newsletterList.title) {
				nlSucText = `Thank you for subscribing to our <span>${this.newsletterList.title}</span> Newsletter`;
			}
			return nlSucText;
		},

		getSubHeader() {
			let nlSubHeader = 'Get doctor-approved health tips, news, and more.';
			if (this.nlConfig.subHeader !== undefined && this.nlConfig.subHeader !== '') {
				nlSubHeader = this.nlConfig.subHeader;
			} else if (this.newsletterList.sub_title) {
				nlSubHeader = this.newsletterList.sub_title;
			}
			return nlSubHeader;
		},

		resetHover() {
			this.closeOverlay = false;
			const overlay = document.querySelector('.global-nav-subscribe');
			if (overlay) {
				overlay.addEventListener('click', () => {
					this.closeOverlay = true;
				});
			}
			this.showHover = true;
			this.isError = false;
			this.isSuccess = false;
			const nlId = this.newsletterList && this.newsletterList.message_id;
			const metricsModuleimp = `nl-hov-imp_${nlId}`;
			const metricsModMast = `nl-mast-sub_${nlId}`;
			if (this.launchTagsAvailability()) {
				window.wmdTrack({ moduleName: metricsModMast });
				window.wmdPageLink({ moduleName: metricsModuleimp });
			} else {
				window.wmdTrack(metricsModMast);
				window.wmdPageLink(metricsModuleimp);
			}
			setTimeout(() => {
				this.nlAutoHoverClose();
			}, this.nlAutoHoverConfig.nlAutoCloseTimeout);
		},
		getPositionValue() {
			const module = this.moduleData;
			let result;
			if (this.location !== undefined) {
				result = this.location;
			} else {
				// eslint-disable-next-line max-len
				let moduleLabel2 = _has(module, 'module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val')
					? module.module_settings.md_pb_module_label2_group.wbmd_pb_module_label2.wbmd_storage_val
					: null;

				// update value to ensure lowercase
				if (moduleLabel2) {
					moduleLabel2 = moduleLabel2.toLowerCase();
				}

				if (moduleLabel2 === null) {
					result = 'middle';
				} else {
					result = moduleLabel2;
				}
			}
			return result;
		},
		disableButton() {
			if (this.isMultiple) {
				if (this.validEmail(this.email) && this.checkList.length > 0) {
					return false;
				}
			} else if (this.validEmail(this.email)) {
				return false;
			}
			return true;
		},
		validEmail(email) {
			// eslint-disable-next-line
			let nlRegExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return nlRegExp.test(email);
		},
		updateArray(nlId) {
			const indexId = this.checkList.indexOf(nlId);
			if (indexId === -1) {
				this.checkList.push(nlId);
			} else {
				this.checkList.splice(indexId, 1);
			}
		},
		launchTagsAvailability() {
			return (document.getElementById('launchtags') !== null);
		},
		getImagePath() {
			let imagePath = '';
			const imgServerUrl = 'https://img.webmd.com/dtmcms/live';
			if (this.newsletterList && this.newsletterList.hover_image_url) {
				if (this.isToc) {
					imagePath = `<img data-src="${imgServerUrl}${this.newsletterList.hover_image_url}"
					src="${imgServerUrl}${this.newsletterList.hover_image_url}" width="50%" loading="lazy">`;
				} else {
					imagePath = `<img data-src="${imgServerUrl}${this.newsletterList.hover_image_url}"
						src="${imgServerUrl}${this.newsletterList.hover_image_url}" loading="lazy">`;
				}
			}
			return imagePath;
		},
		nlAutoHoverOpen() {
			this.showHover = true;
			this.isError = false;
			this.isSuccess = false;
			const bodyElem = document.getElementsByTagName('body')[0];
			if (typeof (bodyElem) !== 'undefined' && bodyElem !== null) {
				bodyElem.id = 'auto-hover-open';
			}
			if (this.launchTagsAvailability()) {
				window.wmdPageLink({ moduleName: 'nl-hov_imp' });
			} else {
				window.wmdPageLink('nl-hov_imp');
			}

			// increment PIM value on NL Hover Display is true
			increment();
			setTimeout(() => {
				this.nlAutoHoverClose();
			}, this.nlAutoHoverConfig.nlAutoCloseTimeout);
		},
		nlAutoHoverClose() {
			if ((document.querySelector('.newsletter-wrapper.overlay')
				.querySelector('.webmd-dialog__wrapper').style.display !== 'none') || this.closeOverlay) {
				if (this.email === '' || this.email === undefined) {
					this.showHover = false;
					if (this.launchTagsAvailability()) {
						window.wmdPageLink({ moduleName: 'nl-hov_col' });
					} else {
						window.wmdPageLink('nl-hov_col');
					}
					this.removeOpenHoverIdFromBodyTag();
				} else {
					setTimeout(() => {
						this.nlAutoHoverClose();
					}, this.nlAutoHoverConfig.nlAutoCloseTimeout);
				}
			}
		},
		removeOpenHoverIdFromBodyTag() {
			const hoverOpenElem = document.getElementById('auto-hover-open');
			if (typeof (hoverOpenElem) !== 'undefined' && hoverOpenElem !== null) {
				document.getElementsByTagName('body')[0].removeAttribute('id');
			}
		},
		focus() {
			this.isFocused = true;
		},
		blur() {
			this.isFocused = false;
		},
		autoHoverDisplay() {
			if (suppressAutoHover.isPageExcluded() === true) {
				return;
			}
			if (this.duAgent.toLowerCase() === 'mobile') {
				// For mobile devices change timeout to 5 sec
				this.nlAutoHoverConfig.nlAutoOpenTimeout = 5 * 1000;
			}
			const autoHoverDisp = suppressAutoHover.nlCookieCheck();
			if (autoHoverDisp) {
				setTimeout(() => {
					this.nlAutoHoverOpen();
				}, this.nlAutoHoverConfig.nlAutoOpenTimeout);
			}
		},
		getNlDetails() {
			let nlObj = {};
			if (this.nlConfig.id !== '' && this.nlConfig.id !== undefined) {
				nlObj = this.nlConfig;
			} else {
				nlObj = this.store.pagedata.newsletterMapping;
			}
			return nlObj;
		},

		getMultiNlDetails() {
			return newsletterMapping.getNewsletterList(this.centerId, this.numOfMultiNls);
		},

	},
	created() {
		this.store = useStore(this.$pinia);
		if (this.chronicId !== undefined) {
			this.moduleData = this.getModuleData;
		}
		if (this.nlConfig.centerId !== '' && (this.nlConfig.id === '' || this.nlConfig.id === undefined)) {
			this.centerId = this.nlConfig.centerId;
		} else {
			this.centerId = this.getCenterId;
		}

		this.position = this.getPositionValue();
		this.isFed = !!(this.store.fed && typeof this.store.fed === 'object');

		/**
		 * When the position is right rail, set the value to multiple by default
		 */
		let checkUnpaginate = false;
		if (this.$pinia && this.store
			&& this.store.cms && this.store.cms.modules
			&& this.store.cms.modules.unPaginate) {
			checkUnpaginate = this.store.cms.modules.unPaginate;
		}
		if (this.position === 'right' && !checkUnpaginate) {
			this.isMultiple = true;
		} else {
			this.isMultiple = false;
		}

		this.newsletterList = this.getNlDetails();

		this.multiNLList = this.getMultiNlDetails();

		this.nlHeader = this.getHeader();

		this.nlSuccessHeader = this.getSuccessHeader();

		this.nlSubHeader = this.getSubHeader();

		this.setThanks();
	},
	mounted() {
		const urlHostName = window.location.host;

		// determine whether page is prod page or not
		this.isProdApiUrl = !(urlHostName.includes('.staging')
			|| urlHostName.includes('.feature')
			|| urlHostName.includes('.qa') || urlHostName.includes('localhost')
			|| urlHostName.includes('.devint'));
		this.duAgent = ua.type || 'Desktop';
		if (window && window.viewAllContent) {
			this.unpaginatedFlag = `addBorder ${this.position}`;
		} else {
			this.unpaginatedFlag = this.position;
		}
		if (this.isInfinite && this.nlType === 'in-article') {
			this.unpaginatedFlag = `ia-nl '${this.position}`;
		}

		/*
		 * LiveRamp requirement https://jira.internetbrands.com/browse/PPE-325153
		 * Set a cookie for the users coming to WebMD site by clicking on
		 * links from WebMD newsletter email
		 */
		if (getParam('mb')) {
			this.setRegUuidCookie();
		}
	},
	watch: {
		autoHover(newValue) {
			if (newValue) {
				this.position = 'overlay';
				this.autoHoverDisplay();
			}
		},
	},
};
</script>
<!-- eslint-disable max-len -->
<style lang="scss">
/*The ad-101 on desktop and tablet & global-nav on mobile are overlapping with auto NL hover*/
/* On Demand newsletter hover is rendering fine*/
/*To fix the overlapping issue, we need to have the following overrides.*/
@import "./stylesheets/variables.scss";
@media (min-width: 47.938em) {
	#auto-hover-open {
		.ad-101 {
			position: unset !important;
		}

		.v-modal {
			z-index: 2000010 !important;
		}

		.webmd-dialog__wrapper {
			z-index: 2000100 !important;
		}
	}
}

@media (max-width: 47.938em) {
	#auto-hover-open {
		.global-nav {
			position: unset !important;
		}
	}
}

.newsletter-wrapper {
	padding-top: 0.5rem;

	//styles for Hover NL
	&.vn-subscribe {
		.webmd-dialog {
			width: px2rem(610);
			min-height: px2rem(576);
		}

		.newsletter-main.overlay {
			display: block;
		}

		.success-reg.overlay,
		.err-reg.overlay {
			display: block;

			.success-content,
			.error-content {
				display: flex;
				flex-direction: column;
				flex-grow: 1;
				justify-content: center;
				min-height: px2rem(330);

				padding: px2rem(30) px2rem(50);

				@media (max-width: 47.938em) {
					padding: px2rem(24) px2rem(20);
				}

				p {
					padding: 0;
					font-size: px2rem(18);
					line-height: 28.8px;
					color: $coral;
					margin-top: 0;
				}

				h2 {
					margin-top: 0;
					margin-bottom: px2rem(16);
					padding: 0;
					font-size: px2rem(32);
					line-height: px2rem(42);
					letter-spacing: 0.32px;

					@media (max-width: 47.938em) {
						font-size: px2rem(24);
						line-height: px2rem(33.6);
						margin-bottom: px2rem(4);
					}
				}

				.see-more-container {
					align-items: center;
					display: flex;
					justify-content: center;
					margin-top: 1rem;

					@media only screen and (max-width: $breakpoint-tablet) {
						margin-bottom: 0.75rem;
					}

					.see-more-btn {
						background: #3557ff;
						border-radius: 4px;
						color: #fff;
						cursor: pointer;
						font-size: 1.125rem;
						font-weight: 600;
						line-height: 28.8px;
						min-width: 150px;
						padding: 8px 16px;
						text-decoration: none;
					}
				}

				.sub-title-text {
					color: #1b1b1b;
					font-size: 1.125rem;
					line-height: 28.8px;
				}
			}
		}
	}

	.addBorder {
		border-top: 5px solid #e8e6e6;
		padding: 0 !important;
	}

	/* Oncology pages requires inline success message.
	The styles will be overridden in oncology repo */
	.inline-suc-msg {
		display: none;
	}

	.newsletter-container {
		padding: 0.5rem;

		h2 {
			font-size: 1.5rem;
		}

		h3 {
			font-size: 1rem;
		}

		&.right {
			border-top: 5px solid #e8e6e6;
			padding: 0.5rem 0 0;
			margin: 0 0 2.8125rem;

			.newsletter-main {
				img {
					display: none;
				}

				h3 {
					font-size: 1.5rem;
					font-weight: bold;
					margin-bottom: 0.875rem;
					text-transform: uppercase;
				}

				.webmd-checkbox__label {
					font-size: 0.9375rem;
				}
			}

			.email-container {
				padding: 0.25rem 0;
				flex-direction: column;

				img {
					display: none;
				}

				.email-input {
					margin-bottom: 0.75rem;
				}
			}

			.success-reg {
				text-align: left;
			}

			.err-reg {
				text-align: left;

				.nl-header-container {
					h2 {
						text-transform: uppercase;
					}
				}
			}
		}

		&.middle {
			.newsletter-main {
				.webmd-logo-container {
					display: inline-flex;
				}

				.nl-header-container {
					h3 {
						font-size: 1.5rem;
						font-weight: bold;
						margin: 0.75rem 0;
					}

					h4 {
						display: none;
					}
				}
			}
		}
	}

	.webmd-dialog {
		background-color: #EDF0FF;
		border-radius: .1875rem;
		margin-top: 0 !important;
		text-align: center;
		top: 7%;
		width: 46.25rem;
	}

	.webmd-dialog__body {
		padding: 0;
	}

	.webmd-dialog__header {
		padding: 0;
	}

	.webmd-dialog__headerbtn {
		right: 0.5rem;
		top: 0.5rem;
	}

	.webmd-dialog__headerbtn:hover .webmd-dialog__close {
		color: #fff;
	}

	.webmd-dialog__close {
		background-color: $white;
		color: #fff;
		-webkit-border-radius: 50%;
		-moz-border-radius: 50%;
		border-radius: 50%;
		padding: 0.0625rem;
		height: px2rem(24);
		width: px2rem(24);

		&::before {
			left: 0;
			position: relative;
			color: $ultramarine;
			font-size: 12px;
			top: px2rem(1);
		}
	}

	.overlay {
		display: flex;
		flex-direction: row;

		.hover-webmd-logo {
			display: inline-block;
			line-height: normal;
			padding: 0.25rem 0 0.5rem;
		}

		.nlhover-image-container {
			img {
				border-radius: 4px;
				height: px2rem(232);
			}
		}

		.nlhov-content-container {
			max-height: 31.25rem;
			padding: px2rem(28) px2rem(50);

			.nl-header-container {
				h2 {
					color: $nl-hover-title;
					font-size: px2rem(32);
					line-height: px2rem(42);
					letter-spacing: px2rem(0.32);
					font-weight: 700;
					margin-top: 0;
					padding: 0.25rem 0;
					padding-top: 0;
				}

				h3 {
					color: $nl-hover-title;
					font-size: px2rem(18);
					font-weight: 400;
					line-height: 160%;
					margin-bottom: px2rem(16);
					text-align: left;
				}
			}

			.email-container {
				display: flex;

				.email-input {
					margin-right: 0;
					width: 67% !important;
				}

				input {
					color: $coral;
					border-top-right-radius: 0;
					border-bottom-right-radius: 0;
					font-size: px2rem(18);
					font-weight: 400;
					height: px2rem(50);
					line-height: normal;
					letter-spacing: px2rem(0.18);
					margin-right: 0;
					padding: 0 px2rem(25);
					text-align: left;

					&::placeholder {
						color: $placeholder-color;
					}
				}

				button {
					border-top-left-radius: 0;
					border-bottom-left-radius: 0;
					height: px2rem(50);
					font-size: px2rem(22);
					letter-spacing: px2rem(0.22);
					margin-top: 0;
					padding: 0 px2rem(25);
					width: px2rem(146);

					&.webmd-button--primary {
						background-color: $ultramarine;

						&:disabled {
							background: #b3b3b3 !important;
							color: #676767;
						}
					}

					span {
						font-weight: 600;
					}
				}
			}

			.nl-disclaimer {
				color: $coral;
				padding: 1rem 0;
				font-size: px2rem(12);
				font-style: normal;
				font-weight: 400;
				line-height: px2rem(16.8);
				letter-spacing: px2rem(0.6);
				text-align: left;

				a {
					color: $ultramarine;
					text-decoration: none;
				}
			}

		}

		.email-container {
			display: block;

			input {
				color: #ababab;
				text-align: center;
			}

			button {
				margin-top: 1rem;
				width: 100%;
			}
		}

		.nl-disclaimer {
			color: $coral;
			padding: 1rem 0;
			text-align: center;

			a {
				text-decoration: none;
			}
		}

		.multie-nl-container {
			display: block;
		}
	}

	.success-reg.overlay,
	.err-reg.overlay {

		.success-content,
		.error-content {
			padding: 2.1875rem 1.5625rem;
			width: 100%;
			text-align: center;

			a {
				color: $ultramarine;
				text-decoration: none;

				&:hover {
					text-decoration: underline;
				}
			}
		}

		.hover-webmd-logo {
			margin-bottom: 1.4375rem;
		}

		.follow-checkmark {
			display: block;
			margin: 0 auto 1rem;
		}

		h2 {
			color: $nl-hover-title;
			font-size: px2rem(32);
			line-height: px2rem(42);
			font-weight: 700;
			margin: 0.5rem 0;

			span {
				font-weight: 700;
			}
		}

		p {
			border-bottom: none;
			color: #000;
			padding: 0.5rem 1rem 1rem;
		}
	}

	.err-reg.overlay {
		.nl-header-container {
			text-align: center;
		}
	}
}

.nl-header-container {
	text-align: left;

	h2 {
		font-size: 1.6875rem;
		margin: 0.5rem 0;
	}

	h3 {
		font-size: 1rem;
		font-weight: 400;
		margin-top: 0.25rem;
	}
}

.newsletter-daily-logo {
	height: auto;
	max-height: 2rem;
	width: 6rem;
}

.email-container {
	display: flex;

	.email-input {
		width: 100% !important;
		margin-right: 0.5rem;
	}

	button {
		height: 2.5rem;
		width: 7.0625rem;
	}

	.webmd-input__inner:focus {
		border: 1px solid #e9e9e9;
		box-shadow: inset 0 1px 3px rgba(0, 0, 0, .06), 0 0 5px rgba(21, 106, 149, .7);
		outline: 0;
	}
}

.err-invalid-email {
	color: #E71717;
	display: flex;
	font-size: 0.75rem;
	font-weight: 400;
	line-height: 1.05rem;
	margin-top: 4px;
}

.nl-disclaimer {
	display: block;
	font-family: "Roboto Condensed", Verdana, sans-serif;
	font-size: 0.875rem;
	line-height: 1.25;
	padding-bottom: 1rem;
	padding-top: 0.75rem;
	text-align: left;

	a {
		color: #187aab;
		text-decoration: none;
	}
}

.success-reg {
	text-align: center;

	h2 {
		font-size: 1.5rem;
		margin-top: 0.25rem;
		margin-bottom: 1rem;

		@media only screen and (max-width: $breakpoint-tablet) {
			margin-bottom: 0.25rem;
		}
	}

	p {
		border-bottom: 1px solid #e9e9e9;
		font-size: 1rem;
		padding-bottom: 0.5rem;
	}

	.see-more-container {
		align-items: center;
		display: flex;
		justify-content: center;
		margin-top: 1rem;

		@media only screen and (max-width: $breakpoint-tablet) {
			margin-bottom: 0.75rem;
		}

		.see-more-btn {
			background: #3557ff;
			border-radius: 4px;
			color: #fff;
			cursor: pointer;
			font-size: 1.125rem;
			font-weight: 600;
			line-height: 28.8px;
			min-width: 150px;
			padding: 8px 16px;
			text-decoration: none;
		}
	}

	.sub-title-text {
		font-size: 1.125rem;
	}
}

.err-reg {
	font-size: 1rem;
	text-align: center;
}

.multie-nl-container {
	display: inline-block;
	padding-bottom: 0.25rem;
	text-align: left;

	.webmd-checkbox.webmd-checkbox--small {
		display: block;
		padding: .375rem 1.5rem .25rem 0;
	}

	.webmd-checkbox+.webmd-checkbox {
		margin-left: 0;
	}

	.webmd-checkbox__input.is-focus .webmd-checkbox__inner {
		outline: auto;
		outline-color: #99bbff;
	}
}

@media only screen and (max-width: 47.938em) {
	.newsletter-wrapper {
		.newsletter-container {
			padding: 0;
		}

		&.vn-subscribe {
			.webmd-dialog {
				top: px2rem(32);
				width: 100%;
				min-height: px2rem(480);
			}
		}

		.webmd-dialog {
			height: auto;
			max-width: 25rem;
			top: 2%;
			width: 95%;
		}

		.webmd-dialog__headerbtn {
			top: 0.5625rem;
			right: 0.5625rem;
		}

		.webmd-dialog__close {
			padding: 0;
		}

		.overlay {
			flex-direction: column-reverse;

			.hover-webmd-logo {
				padding: 1rem 0 0.125rem;
			}

			.nlhover-image-container {
				img {
					height: auto;
				}
			}

			.nlhov-content-container {
				max-width: 25rem;
				padding: px2rem(24) px2rem(20);
				width: 100%;

				.nl-header-container {
					h2 {
						font-size: px2rem(24);
						line-height: px2rem(33.6);
						margin: 0;
						padding-bottom: 0;
					}

					h3 {
						margin-bottom: 0;
					}

				}

				.email-container {
					display: block;
					padding: 12px 0 0 0;

					.email-input {
						width: 100% !important;
					}

					button {
						border-radius: px2rem(4);
						width: 100%;
					}
				}

				.nl-disclaimer {
					line-height: px2rem(14.4);
					letter-spacing: px2rem(0.6);
					padding-bottom: 0;
				}
			}

			.email-container {
				padding: 1rem;

				.email-input {
					margin-bottom: 0.5rem;

				}

				button {
					margin-top: 0.25rem;
					width: 100%;
				}
			}

			.nl-disclaimer {
				font-size: 0.75rem;
				line-height: 1.33;
				padding: 0.5rem 1rem 1rem;
			}

			.nlhover-image-container {
				img {
					width: 100%;
				}
			}
		}

		.success-reg.overlay {
			.success-content {
				padding: 1rem;
				width: 100%;
			}

			.hover-webmd-logo {
				margin-bottom: 1rem;
				padding-top: 0.25rem;
			}

			.follow-checkmark {
				display: block;
				margin: 0 auto 0.5rem;
			}

			h2 {
				font-size: 1.375rem;
				line-height: 1.09;
				padding: 0.5rem 2rem;

				span {
					font-weight: 700;
				}
			}

			p {
				border-bottom: none;
				color: #000;
				margin-top: 0.5rem;
				padding: 0 0.5rem 0.5rem;
			}
		}

		.err-reg.overlay {
			.error-content {
				width: 100%;
			}
		}
	}

	.right {
		.webmd-checkbox__label {
			margin-right: 2rem;
		}
	}
}

@media only screen and (min-width: $tablet) {
	.ia-nl {
		min-width: 46.875rem;
		padding-left: 0;

		.newsletter-main {
			background-color: $nebula;
			border-radius: 0.25rem;
			display: flex;
			flex-direction: column;
			margin: 1.25rem 0 1.875rem 0;
			min-height: 0;
			min-width: 25rem;
			padding: 2.125rem;
			width: 46.875rem;

			.header-container {
				align-items: center;
				display: flex;
				flex-direction: row-reverse;
				margin-bottom: 1.25rem;

				.nl-header-container {
					h3 {
						color: $coral;
						font-size: 1.25rem;
						font-weight: 700;
						line-height: 1.4;
						margin-bottom: 12px;
						margin-top: 0;
					}

					h4 {
						display: block !important;
						font-family: $base-font-family-sans;
						font-size: 1.125rem;
						font-weight: 400;
						line-height: 1.6;
						margin: 0;
					}
				}

				.image-container {
					display: block;
					height: 8rem;
					overflow: inherit;
					width: 65%;

					img {
						border-radius: 4px;
						border-style: none;
						float: right;
						height: 8rem;
					}
				}

				.success-reg {
					margin-right: 1.125rem;
					text-align: start;

					h2 {
						color: $coral;
						font-family: $base-font-family-sans;
						font-size: 1.25rem;
						font-weight: 700;
						line-height: 1.4;
						margin: 0;
					}

					p {
						border-bottom: 0;
						color: $coral;
						font-family: $base-font-family-sans;
						font-size: 1.125rem;
						font-weight: 400;
						line-height: 1.6;
						margin: 0.75rem 0 0 0;
						padding-bottom: 0;

						a {
							color: $ultramarine;
							text-decoration: none;

							&:hover {
								text-decoration: underline;
							}
						}
					}
				}
			}

			.content-container {
				padding: 0;
				width: 100%;

				.webmd-logo-container {
					display: none !important;
				}

				.sucess-webmd-logo {
					margin-bottom: 1.25rem;
					margin-top: 2.5rem;
					text-align: center;
				}

				.series-select {
					display: inline-flex;
					gap: 0.8125rem;
					justify-content: space-between;
					margin-bottom: 0.75rem;

					.webmd-checkbox__label {
						padding-left: 0.375rem;
					}

					.webmd-checkbox {
						align-items: center;
						color: $coral;
						display: flex;
						font-size: 0.875rem;
						line-height: 1.40;
						letter-spacing: 0.7px;
						margin-left: 0 !important;
						padding: 0 !important;

						&__input {
							height: 1.125rem;
						}

						&:hover {
							background: transparent;
						}

						.webmd-checkbox__inner {
							border: 2px solid $ultramarine;
							height: 1.1375rem;
							width: 1.125rem;
							border-radius: 0.3125rem;
						}

						&.is-checked .webmd-checkbox__inner {
							background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xLjM4NCAzLjExNWwyLjI1IDIuMDE5IDMuNzUtNC4wMzgiIHN0cm9rZT0iIzM1NTdGRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=") no-repeat;
							background-position: 50%;
							background-size: 0.5625rem;
						}
					}
				}

				.email-container {
					.email-input {
						margin-right: 0;
						width: 100% !important;

						.webmd-input__inner {
							border: 1px solid #CCCCE7;
							border-radius: 5px 0px 0px 5px;
							color: $coral;
							font-size: 0.875rem;
							height: 45px;
							letter-spacing: 0.14px;
							padding: 0 0.75rem 0 0.75rem;
						}
					}

					button {
						border-radius: 0px 5px 5px 0px;
						font-size: 18px;
						font-weight: 600;
						height: 45px;
						line-height: 1.6;
						padding: 0 .25rem;
						width: 25.6%;
					}

					.webmd-button--primary {
						background-color: $ultramarine;
					}

					.webmd-button--primary:disabled {
						background-color: #b3b3b3;
						color: #676767;
					}
				}

				.nl-disclaimer {
					color: $coral;
					font-family: $base-font-family-sans;
					font-size: 0.75rem;
					line-height: 1.4;
					padding-bottom: 0;

					a {
						color: $ultramarine;
					}
				}
			}
		}
	}
}

@media only screen and (min-width: $tablet) and (max-width: $breakpoint-tablet-big) {
	.ia-nl {
		min-width: 44.5rem;

		.newsletter-main {
			width: 44.5rem;
		}
	}
}

.footer-nl-social {
	.nl-header-container {
		h4 {
			display: block !important;
			color: $white;
			font-family: $base-font-family-sans;
			font-size: 1.125rem;
			font-style: normal;
			font-weight: 400;
			line-height: 1.1111rem;
		}
	}

	.content-container {
		.series-select {
			display: flex;
			align-items: flex-start;

			@media only screen and (max-width: 47.875rem) {
				flex-direction: column;
			}

			.webmd-checkbox__label {
				color: $white;
				font-family: $base-font-family-sans;
				font-size: 1rem;
				font-style: normal;
				font-weight: 400;
				line-height: 1.6rem;
			}

			.webmd-checkbox:hover {
				background: initial;
				color: initial;
				border: initial;
			}

			.webmd-checkbox__inner {
				border: 0.125rem solid $ultramarine;
				background-color: #000625;
			}

			.webmd-checkbox {
				display: inline-block;
				padding-right: 0;
				padding-left: 0.125rem;

				@media only screen and (max-width: 47.875rem) {
					margin-left: 0;
				}
			}

			.webmd-checkbox__input.is-checked .webmd-checkbox__inner {
				background-color: #000625;
			}

			.webmd-checkbox__input.is-checked .webmd-checkbox__inner.webmd-checkbox--checkmarkershapedefault.webmd-checkbox--checkmarkercolorgreen {
				background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xLjM4NCAzLjExNWwyLjI1IDIuMDE5IDMuNzUtNC4wMzgiIHN0cm9rZT0iIzM1NTdGRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=);
			}
		}
	}
}

.nlhov-content-container {
	.series-select {
		display: flex;
		justify-content: space-between;
		margin-top: px2rem(12);
		margin-bottom: px2rem(32);

		.webmd-checkbox__label {
			padding-left: px2rem(5);
		}

		.webmd-checkbox {
			align-items: center;
			color: #1B1B1B;
			display: flex;
			margin-left: 0 !important;
			padding: 0 !important;

			&__input {
				height: px2rem(18);
			}

			&:hover {
				background: transparent;
			}

			.webmd-checkbox__inner {
				border: 2px solid $ultramarine;
				height: px2rem(18.2);
				width: px2rem(18);
				border-radius: 5px;
			}

			&.is-checked .webmd-checkbox__inner {
				background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOSIgaGVpZ2h0PSI3IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik0xLjM4NCAzLjExNWwyLjI1IDIuMDE5IDMuNzUtNC4wMzgiIHN0cm9rZT0iIzM1NTdGRiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz48L3N2Zz4=") no-repeat;
				background-position: 50%;
				background-size: px2rem(9);
			}
		}
	}

	@media only screen and (max-width: 47.938em) {
		.series-select {
			display: block;
			margin-bottom: 0;

			.webmd-checkbox {
				padding-bottom: 10px !important;
			}
		}
	}
}

.footer-nl-social {
	.success-reg {
		h2 {
			font-weight: 600;
			line-height: 50px;
			text-align: left;

			@media (max-width: $mobile) {
				text-align: center;
			}
		}

		.see-more-container {
			align-items: self-start;
			justify-content: left;

			@media (max-width: $mobile) {
				justify-content: center;
			}
		}

		.sub-title-text {
			color: #ffffff;
			line-height: 20px;

			@media (max-width: $mobile) {
				justify-content: center;
			}
		}
	}
}

.right-cont,
.in-art-ty {
	h2 {
		color: #1b1b1b;
		font-size: 1.375rem;
		font-weight: 700;
		line-height: 30.8px;
		margin-bottom: 0.75rem;

		@media (max-width: $breakpoint-tablet) {
			font-size: 2rem;
			line-height: 42px;
			margin-bottom: 1rem;
		}

		@media (max-width: $mobile) {
			font-size: 1.5rem;
			line-height: 33.6px;
			margin-bottom: 0.25rem;
		}
	}

	.see-more-container {
		align-items: left;
		display: flex;
		justify-content: left;
		margin-top: 1rem;

		@media (max-width: $breakpoint-tablet) {
			margin-bottom: 0.75rem;
		}

		@media (max-width: $mobile) {
			align-items: center;
			justify-content: center;
		}

		.see-more-btn {
			align-items: center;
			background: #3557ff;
			border-radius: 4px;
			color: #fff;
			cursor: pointer;
			display: flex;
			font-size: 1.125rem;
			font-weight: 600;
			justify-content: center;
			line-height: 28.8px;
			min-width: 150px;
			padding: 8px 16px;
			text-decoration: none;
		}
	}

	.sub-title-text {
		font-size: 1.125rem;
		line-height: 28.8px;
	}
}

.webmd-message-box__wrapper[aria-label="Thank you for visiting WebMD"] {
	z-index: 999999999 !important;
}
</style>
